import React, { useState } from 'react'
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { GoogleLoginButton } from "react-social-login-buttons"
import { useAuth } from '../../../contexts/AuthContext'

import { createUser } from '../../../firebase/firebase'
import { googleProvider } from "../../../firebase/firebaseConfig"

export const SignupForm = () => {
    const history = useHistory()
    const { currentUser, emailSignup, providerLogin } = useAuth()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [userSignup, setUserSignup] = useState({
        email: '',
        password: '',
        passwordConfirm: '',
        firstName: '',
        lastName: ''
    })

    const onChange = (e) => {
        setUserSignup({ ...userSignup, [e.target.name]: e.target.value })

    }

    async function handleSubmit(e) {
        e.preventDefault()

        if (userSignup.password != userSignup.passwordConfirm) {
            return setError('Password do not match')
        }
        try {
            setError('')
            setLoading(true)
            const response = await emailSignup(userSignup.email, userSignup.password)
            if (response.user.uid) {
                const newUser = {
                    id: response.user.uid,
                    email: userSignup.email,
                    firstName: userSignup.firstName,
                    lastName: userSignup.lastName,
                    role: 'regular'
                }
                createUser(newUser).then(() => {
                    history.push('/')
                })

            }

        }
        catch (error) {
            setError(error.message)

        }
        setLoading(false)

    }

    async function handleProviderLogin(e) {
        try {
            setError('')
            setLoading(true)
            const response = await providerLogin(googleProvider)

            if (response.user) {
                const newUser = {
                    id: response.user.uid,
                    email: response.user.email,
                    firstName: response.additionalUserInfo.profile.given_name,
                    lastName: response.additionalUserInfo.profile.family_name,
                }
                createUser(newUser).then(() => {
                    history.push('/')
                })
            }

        }
        catch (error) {
            setError(error.message)
            console.log(error)

        }
        setLoading(false)

    }






    return (
        <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <Card>
                <Card.Body>
                    <h2 className="text-center my-4">Sign Up</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3 justify-content-center">
                            <Col xs={5}>
                                <Form.Control

                                    onChange={onChange}
                                    type="text"
                                    placeholder="First Name"
                                    value={userSignup.firstName}
                                    name='firstName'
                                />

                            </Col>

                            <Col xs={5}>
                                <Form.Control

                                    onChange={onChange}
                                    type="text"
                                    placeholder="Last Name"
                                    value={userSignup.lastName}
                                    name='lastName'
                                />

                            </Col>
                        </Row>

                        <Row className="mb-3 justify-content-center">
                            <Col xs={10}>
                                <Form.Control

                                    onChange={onChange}
                                    type="email"
                                    placeholder="Email"
                                    value={userSignup.email}
                                    name='email'
                                />
                            </Col>


                        </Row>
                        <Row className="mb-3 justify-content-center">
                            <Col xs={10}>
                                <Form.Control

                                    onChange={onChange}
                                    type="password"
                                    placeholder="Password"
                                    value={userSignup.password}
                                    name='password'
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3 justify-content-center">
                            <Col xs={10}>
                                <Form.Control

                                    onChange={onChange}
                                    type="password"
                                    placeholder="Confirm Password"
                                    value={userSignup.passwordConfirm}
                                    name='passwordConfirm'
                                />
                            </Col>

                        </Row>
                        <Row className='justify-content-center'>
                            <Col xs={8} className='text-center'>
                                <Button className='text-uppercase btn-lg' type='submit'>
                                    Signup
                                </Button>
                            </Col>
                        </Row>

                    </Form>
                    <Row className='justify-content-center py-3'>
                        <Col xs={8} xl={6} className='text-center'>
                            <GoogleLoginButton onClick={handleProviderLogin} />
                        </Col>
                    </Row>






                </Card.Body>




            </Card>


        </div>

    )
}